import {CIVILITE} from '../model';

export default factory;

function factory() {
  return (value) => {
    switch (value) {
      case CIVILITE.MADAME:
        return 'Madame';
      case CIVILITE.MONSIEUR:
        return 'Monsieur';
      default:
        return '';
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/base/filters/civilite.filter.js